import angular from 'angular';
import SellingTerminalsWidgetComponent from './selling-terminals-widget-component';

export default angular.module('selling-terminals-widget', []).component('sellingTerminals', new SellingTerminalsWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/selling-terminals/selling-terminals-widget-module.js